import { useState, useMemo } from 'react'
import { sortBy } from 'lodash'
import Link from 'next/link'

import { Layout, ProductSlider, RelatedSlider, Currency, Badge } from '../../../../components/front'
import { useCart } from '../../../../components/front/Cart'
import {
    getProductCategories,
    getUniqueProducts,
    getRandomProductsFromCategory,
    increaseProductVisit,
    getStaticDate
} from '../../../../lib'
import { withSession } from '../../../../utils/server'
import { sleep } from '../../../../utils'

export let getServerSideProps = withSession(async ({ query, params, res }) => {
    const hier = await getProductCategories()
    const data = await getStaticDate()

    if (typeof params === 'undefined') {
        console.warn('possible XSS', query)
        await sleep(5000)
        res.writeHead(302, { Location: '/' })
        res.end()
        return { props: {} }
    }
    const entities = await getUniqueProducts({
        filter: { id: params.id },
        options: { includeVariants: true }
    })

    if (!entities || entities.length === 0) {
        if (res) {
            console.warn('Could not find product', params)
            await sleep(5000)
            res.writeHead(302, { Location: '/' })
            res.end()
        }
        return { props: {} }
    }

    const relatedProducts = await getRandomProductsFromCategory(entities[0].id, entities[0].category_id, 5)

    await increaseProductVisit(entities[0].id)

    return {
        props: {
            products: [entities[0], ...entities[0].variants],
            productCategories: hier,
            relatedProducts: relatedProducts,
            footer: data['about_footer'].content
        }
    }
})

export default function Detail({ products, productCategories, relatedProducts, footer }) {
    console.log(products)
    const [currentId, setCurrentId] = useState(products[0].id)
    const product = useMemo(() => {
        return products.find((p) => p.id === (currentId || products[0].id)) || products[0]
    }, [products, currentId])
    const cart = useCart()

    const gallery_images = useMemo(() => {
        if (!product) return []
        let gallery_images_arr = Array.isArray(product.metas.gallery) ? product.metas.gallery : [product.metas.gallery]
        //if a variant does not have gallery
        if (currentId !== products[0].id && (gallery_images_arr.length === 0 || !gallery_images_arr[0]?.metas?.gallery))
            gallery_images_arr = Array.isArray(products[0].metas.gallery)
                ? products[0].metas.gallery
                : [products[0].metas.gallery]
        return gallery_images_arr.filter((meta) => meta?.value)
    }, [product])
    const variantByTitle = useMemo(() => {
        const titles = products.map((p) => p?.metas?.model?.value).filter((p) => p)
        let lastTitle = null
        for (const title of titles) {
            if (lastTitle !== null && title !== lastTitle) return true
            lastTitle = title
        }
        return false
    }, [products])

    function ColorList() {
        if (products.filter((product) => product.metas?.color?.value).length === 0) return null
        return (
            <>
                <span className="text-gray-600 ml-2">رنگ:</span>
                {products.map((product) =>
                    product.metas?.color?.value ? (
                        <a
                            key={product.id}
                            onClick={() => {
                                setCurrentId(product.id)
                            }}
                            className={'cursor-pointer border-solid'}
                        >
                            <span
                                style={{ backgroundColor: product.metas?.color?.value }}
                                className={`rounded-full w-8 h-8 border ${
                                    currentId === product.id ? 'border-black' : ''
                                } inline-flex`}
                            ></span>
                        </a>
                    ) : null
                )}
            </>
        )
    }
    function TitleList() {
        return sortBy(products, 'id').map((product) => (
            <a
                key={product.id}
                onClick={() => {
                    setCurrentId(product.id)
                }}
                className={`cursor-pointer border-solid py-1 px-3 border border-purple-300 rounded-xl mt-1 ${
                    currentId === product.id ? 'bg-purple-300' : ''
                }`}
            >
                <span className={'whitespace-nowrap'} itemProp={currentId === product.id ? 'model' : ''}>
                    {product?.metas?.model?.value}
                </span>
            </a>
        ))
    }

    async function updateQty(product, qty) {
        const currentQty = cart.get(product.id)?.qty || 1

        if (qty === '+') {
            qty = currentQty + 1
            //check for max stock
        } else if (qty === '-') {
            qty = currentQty - 1
        } else qty = Number(qty)
        if (qty < 1) qty = 1

        const stock = Number(product?.metas?.stock?.value)
        if (isNaN(stock)) return

        if (qty > stock) qty = stock
        if (stock <= 0) qty = 0

        await cart.update(product.id, qty)
    }

    if (!product) return null
    return (
        <Layout menu={productCategories} footer={{ about: footer }}>
            <div className="bg-gray-200 p-4">
                <div className="grid grid-col-1 gap-y-2 lg:pt-10 lg:grid-cols-3 lg:gap-2">
                    <div className="bg-white rounded-xl p-2 order-last lg:order-first">
                        <h3 className="text-gray-600 text-center mb-2 font-bold text-lg">مشخصات</h3>
                        <div className="p-4 flex flex-col h-80 2xl:h-5/6 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-pink-200 overflow-y-auto">
                            {(product?.metas?.width?.value ||
                                product?.metas?.length?.value ||
                                product.metas.height?.value) && (
                                <div className="bg-gray-200 rounded-lg flex p-2 mb-2 last:m-0">
                                    <span className="mr-4 w-32 text-gray-600">ابعاد</span>
                                    <span className="text-gray-600" dir="ltr">
                                        {[
                                            product.metas.width?.value,
                                            product.metas.length?.value,
                                            product.metas.height?.value
                                        ]
                                            .filter((i) => i)
                                            .join(' x ')}
                                    </span>
                                </div>
                            )}

                            {sortBy(product.metas_cus, (m) => m?.key).map((k) => (
                                <div key={k.id} className="bg-gray-200 rounded-lg flex p-2 mb-2 last:m-0">
                                    <span className="mr-4 w-32 text-gray-600">{k.key}</span>
                                    <span className="text-gray-600">{k.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-2">
                        <div className="bg-white rounded-xl p-4 grid grid-cols-1 lg:grid-cols-2 gap-4 relative">
                            {product.sale_price && product.sale_price > 0 && <Badge text={'20% تخفیف'} type="off" />}
                            <div
                                className={`flex flex-col ${
                                    product.sale_price && product.sale_price > 0 ? 'p-4 lg:mt-8' : 'p-4'
                                }`}
                            >
                                <h2 className="font-bold text-2xl text-gray-600 mb-2">{product.name}</h2>
                                <h3 className="font-bold text-gray-600 inline-block ml-4">
                                    {product?.metas?.alt?.value}
                                </h3>

                                <a
                                    href={`/products/${product.category_name || products[0].category_name}`}
                                    className=""
                                >
                                    <span className="text-pink-600 text-sm px-2 bg-pink-200 rounded-xl">
                                        {product.category_name || products[0].category_name}
                                    </span>
                                </a>
                                {variantByTitle && (
                                    <div className="flex mt-4 space-x-1 items-baseline flex-wrap">
                                        <span className="text-gray-600 ml-2">مدل:</span>
                                        <TitleList />
                                    </div>
                                )}
                                {!variantByTitle && (
                                    <div className="flex mt-4 space-x-1">
                                        <ColorList />
                                    </div>
                                )}
                                <p className="whitespace-pre-wrap mt-6 pr-6 list-disc text-gray-600 h-20 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-pink-200 overflow-y-auto">
                                    {product.des}
                                </p>
                                <div className="flex items-center flex-wrap mt-auto">
                                    {product.metas.stock.value > 0 && product.metas.price?.value > 0 && (
                                        <>
                                            {cart.exists(product.id) && (
                                                <>
                                                    <span className="text-gray-600 ml-2">تعداد</span>
                                                    <div className="w-24">
                                                        <div className="flex">
                                                            <input
                                                                value={cart.get(product.id)?.qty || 1}
                                                                type="text"
                                                                className="bg-white text-sm text-gray-900 text-center focus:outline-none border border-gray-300 h-10 focus:border-gray-400 rounded-md w-full"
                                                                onChange={(e) => updateQty(product, e.target.value)}
                                                            />
                                                            <div className="w-8 flex flex-col justify-items-center align-middle">
                                                                <button
                                                                    className="w-full rounded-lg border-pink-400 text-pink-500"
                                                                    style={{ height: 20 }}
                                                                    onClick={() => updateQty(product, '+')}
                                                                >
                                                                    <img
                                                                        className="w-full2"
                                                                        src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgZmlsbD0ibm9uZSIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiB3aWR0aD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuNzA3MSAxMi43MDcxQzE0LjMxNjYgMTMuMDk3NiAxMy42ODM0IDEzLjA5NzYgMTMuMjkyOSAxMi43MDcxTDEwIDkuNDE0MjFMNi43MDcxMSAxMi43MDcxQzYuMzE2NTggMTMuMDk3NiA1LjY4MzQyIDEzLjA5NzYgNS4yOTI4OSAxMi43MDcxQzQuOTAyMzcgMTIuMzE2NiA0LjkwMjM3IDExLjY4MzQgNS4yOTI4OSAxMS4yOTI5TDkuMjkyODkgNy4yOTI4OUM5LjY4MzQyIDYuOTAyMzcgMTAuMzE2NiA2LjkwMjM3IDEwLjcwNzEgNy4yOTI4OUwxNC43MDcxIDExLjI5MjlDMTUuMDk3NiAxMS42ODM0IDE1LjA5NzYgMTIuMzE2NiAxNC43MDcxIDEyLjcwNzFaIiBmaWxsPSIjNEE1NTY4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="
                                                                    />
                                                                </button>
                                                                <button
                                                                    className="w-full rounded-lg border-pink-400 text-pink-500"
                                                                    style={{ height: 20 }}
                                                                    onClick={() => updateQty(product, '-')}
                                                                >
                                                                    <img
                                                                        className="w-full2"
                                                                        src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgZmlsbD0ibm9uZSIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiB3aWR0aD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4yOTI4OSA3LjI5Mjg5QzUuNjgzNDIgNi45MDIzNyA2LjMxNjU4IDYuOTAyMzcgNi43MDcxMSA3LjI5Mjg5TDEwIDEwLjU4NThMMTMuMjkyOSA3LjI5Mjg5QzEzLjY4MzQgNi45MDIzNyAxNC4zMTY2IDYuOTAyMzcgMTQuNzA3MSA3LjI5Mjg5QzE1LjA5NzYgNy42ODM0MiAxNS4wOTc2IDguMzE2NTggMTQuNzA3MSA4LjcwNzExTDEwLjcwNzEgMTIuNzA3MUMxMC4zMTY2IDEzLjA5NzYgOS42ODM0MiAxMy4wOTc2IDkuMjkyODkgMTIuNzA3MUw1LjI5Mjg5IDguNzA3MTFDNC45MDIzNyA4LjMxNjU4IDQuOTAyMzcgNy42ODM0MiA1LjI5Mjg5IDcuMjkyODlaIiBmaWxsPSIjNEE1NTY4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="
                                                                    />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            <span className="text-2xl text-purple-600 mr-4 inline-flex">
                                                <Currency product={product} qty={cart.get(product.id)?.qty || 1} />
                                            </span>
                                        </>
                                    )}
                                    {(product.metas.stock.value == undefined ||
                                        product.metas.stock.value == null ||
                                        product.metas.stock.value <= 0 ||
                                        product.metas.price.value <= 0) && (
                                        <span className="text-2xl text-pink-300 bg-gray-100 rounded-xl py-2 px-4">
                                            اتمام موجودی
                                        </span>
                                    )}
                                </div>
                                {!cart.exists(product.id) && (
                                    <button
                                        className={
                                            product.metas.stock.value > 0 && product.metas.price.value > 0
                                                ? 'bg-purple-400 text-purple-100 text-xl px-4 py-2 rounded-lg  w-full lg:w-64 mt-4 felx block  '
                                                : 'hidden'
                                        }
                                        onClick={async () => {
                                            await cart.add(product.id)
                                        }}
                                    >
                                        اضافه به سبد خرید
                                    </button>
                                )}
                                {cart.exists(product.id) && (
                                    <>
                                        <span className="text-green-600">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="inline"
                                                style={{ width: 24 }}
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M5 13l4 4L19 7"
                                                />
                                            </svg>{' '}
                                            {product.name} در سبد خرید شما قرار گرفت
                                            <Link href="/cart">
                                                <a className="bg-purple-500 text-white inline-block px-2 py-1 mr-2 rounded-xl">
                                                    مشاهده سبد
                                                </a>
                                            </Link>
                                        </span>
                                    </>
                                )}
                            </div>
                            <div className="order-first lg:order-last">
                                <ProductSlider images={gallery_images} />
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="bg-white rounded-xl p-4 grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4 thinBody text-center">
                    <ShopFeatures />
                </div> */}
                <div className="w-full mt-10 p-4">
                    <h2 className="text-lg font-bold text-purple-400 text-right border-b border-gray-300 mb-6">
                        <span className="mr-20 border-b-2 border-purple-400">محصولات مرتبط</span>
                    </h2>
                    <RelatedSlider className="p-2" items={relatedProducts}></RelatedSlider>
                </div>
            </div>
            <script type="application/ld+json">{product?.metas?.schemam?.value}</script>
        </Layout>
    )
}
